module.exports = __webpack_public_path__ + "images/66cfba91c45bd02be0925e748943848e.png";